import { ResponseOrganization } from "@dashboard-v3/api";
import apiRequest from "utils/apiRequestWithErrorCode";

export async function fetchOrganization(): Promise<ResponseOrganization> {
  return apiRequest("GET", "/organization");
}
